import { useQuery } from "@tanstack/react-query";
import { fetchQuizInstructions } from "../services/quizInstructionService";

export function useQuizInstructions(params = {}, options = {}) {
  return useQuery({
    queryKey: ["quizInstructions", params],
    queryFn: async () => {
      const { payload } = await fetchQuizInstructions(params);
      return payload || {};
    },
    enabled:
      Boolean(params?.category_id) &&
      Number(params?.category_id) > 0 &&
      (options.enabled ?? true),
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 2,
    placeholderData: (previousData) => previousData ?? {},
  });
}
